import { DateRangeResponseModel } from "app/vbt-ticari/common/_models/DateRangeResponseModel";


export class GlobalSearchRequestModel {
    UUId: string;
    SearchKey: string;
    IssueDate: DateRangeResponseModel;
    MyCustomList: boolean;
    CustomerId: number;
    CustomerFirmId: number;

    SearchOutgoingInvoice: boolean;
    SearchIncomingInvoice: boolean;
    SearchMyCustomIncomingInvoice: boolean;
    SearchEArchiveInvoice: boolean;
    SearchOutgoingDespatchAdvice: boolean;
    SearchIncomingDespatchAdvice: boolean;
    SearchMyCustomIncomingDespatchAdvice: boolean;
    SearchCreditNote: boolean;
    SearchSMM: boolean;
    SearchMigratedOutgoingInvoice: boolean;
    SearchMigratedIncomingInvoice: boolean;

    constructor() {
        this.IssueDate = new DateRangeResponseModel();
        
        this.SearchOutgoingInvoice = true;
        this.SearchIncomingInvoice = true;
        this.SearchMyCustomIncomingInvoice = true;
        this.SearchEArchiveInvoice = true;
        this.SearchOutgoingDespatchAdvice = true;
        this.SearchIncomingDespatchAdvice = true;
        this.SearchMyCustomIncomingDespatchAdvice = true;
        this.SearchCreditNote = true;
        this.SearchSMM = true;
        this.SearchMigratedOutgoingInvoice = true;
        this.SearchMigratedIncomingInvoice = true;
    }
}